/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import { useEdition } from '../../contexts/EditionContext';
import AddToFavoritesButton from '../buttons/AddToFavorites';
import Link from '../partials/Link';
import Poster from '../partials/Poster';
import Tag from '../partials/Tag';

import styles from '../../../styles/cards/film.module.scss';

const propTypes = {
    item: AppPropTypes.film,
    isDark: PropTypes.bool,
    isModal: PropTypes.bool,
    isFocusable: PropTypes.bool,
    withFavoriteButton: PropTypes.bool,
    openFilmModal: PropTypes.func,
    selected: PropTypes.bool,
    withYear: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    item: null,
    isDark: false,
    isModal: false,
    isFocusable: true,
    withFavoriteButton: false,
    openFilmModal: null,
    selected: false,
    withYear: false,
    className: null,
};

const FilmCard = ({
    item,
    isDark,
    isModal,
    isFocusable,
    withFavoriteButton,
    openFilmModal,
    selected,
    withYear,
    className,
}) => {
    const currentEdition = useEdition();
    const { handle = null } = currentEdition || {};
    const { title = null, url = null, edition = null } = item || {};
    const { handle: year = null } = edition || {};

    const onClickLink = useCallback(
        (e) => {
            if (openFilmModal !== null && isModal) {
                e.preventDefault();
                openFilmModal(item);
            }
        },
        [openFilmModal, item, isModal],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isDark]: isDark,
                    [styles.selected]: selected,
                },
            ])}
        >
            <Link
                className={styles.posterLink}
                href={url}
                tabIndex={isFocusable ? '' : '-1'}
                onClick={onClickLink}
            >
                {year !== null && withYear ? (
                    <Tag
                        className={styles.tag}
                        label={year}
                        color={year === handle ? 'highlight' : 'dark'}
                    />
                ) : null}
                <Poster className={styles.poster} item={item} isDark={isDark} />
            </Link>
            <div className={styles.content}>
                {withFavoriteButton ? (
                    <AddToFavoritesButton
                        className={classNames(styles.favoriteButton)}
                        iconClassName={styles.buttonIcon}
                        item={item}
                        loginNext={url}
                        withoutLabel
                        isDark
                    />
                ) : null}
                <h2 className={styles.title}>
                    <Link
                        className={styles.titleLink}
                        href={url}
                        tabIndex={isFocusable ? '' : '-1'}
                        onClick={onClickLink}
                    >
                        {title}
                    </Link>
                </h2>
            </div>
        </div>
    );
};

FilmCard.propTypes = propTypes;
FilmCard.defaultProps = defaultProps;

export default FilmCard;
